
import * as React from 'react'

// components
import CustomDrawer from '../../../components/Drawer';

// blocks
import DrawerContainer from './Container'

interface Props { }
const DrawerInfo = React.forwardRef((props: Props, ref: any) => {

  const refDrawer = React.useRef<any>(null);

  React.useImperativeHandle(ref, () => ({
    open: () => {
      refDrawer?.current.open()
    },
    close: () => {
      refDrawer?.current.close()
    }
  }))

  return (
    <CustomDrawer
      backdrop
      contentPadding={20}
      placement='right'
      title="Tools Panel"
      ref={refDrawer}>
      <div style={{
        height: '100%'
      }}>
        <DrawerContainer />
      </div>
    </CustomDrawer>
  );
})

export default DrawerInfo
